export default "__VITE_ASSET__CFG7oyrV__"